"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var icons_material_1 = require("@mui/icons-material");
var material_1 = require("@mui/material");
var Icon_1 = __importDefault(require("@mui/material/Icon"));
var ListItemButton_1 = __importDefault(require("@mui/material/ListItemButton"));
var ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var system_1 = require("@mui/system");
var react_router_dom_1 = require("react-router-dom");
var context_1 = require("../../../context");
var ListItemButtonCustom = (0, system_1.styled)(ListItemButton_1.default)(function (_a) {
    var theme = _a.theme, selected = _a.selected, open = _a.open;
    return ({
        marginLeft: !open ? '20px' : '0px',
        marginRight: !open ? '20px' : '0px',
        color: selected ? theme.palette.secondary.main : 'inherit',
        borderRadius: '5px',
    });
});
var ListItemButtonParentCustom = (0, system_1.styled)(ListItemButton_1.default)(function (_a) {
    var theme = _a.theme, selected = _a.selected, open = _a.open;
    return ({
        color: selected ? theme.palette.secondary.main : 'inherit',
        borderRadius: '5px',
    });
});
var ListItemButtonChildCustom = (0, system_1.styled)(ListItemButton_1.default)(function (_a) {
    var theme = _a.theme, selected = _a.selected, open = _a.open;
    return ({
        marginLeft: open ? '0px' : '10px',
        marginRight: open ? '0px' : '10px',
        color: selected ? theme.palette.secondary.main : 'inherit',
        borderRadius: '5px',
    });
});
var menuList = [
    {
        title: 'Dashboard',
        href: '/dashboard',
        icon: 'dashboard',
        isGroup: false,
    },
    {
        title: 'Campañas',
        href: '/campaigns',
        icon: 'redeem',
        parent: 'merchant-campaigns',
        isGroup: false,
    },
    {
        title: 'Clientes',
        href: '/clients',
        icon: 'groups',
        parent: 'merchant-clients',
        isGroup: false,
    },
    {
        title: 'Tarjetas',
        href: '/client-cards',
        icon: 'credit_card',
        parent: 'merchant-client-cards',
        isGroup: false,
    },
    { title: 'Administración', isSectionTitle: true, isGroup: false },
    {
        title: 'Clientes B2B',
        icon: 'store',
        isGroup: true,
        parent: 'merchants',
        submenu: [
            {
                title: 'Lista de Clientes B2B',
                href: '/admin/merchants',
                isGroup: false,
            },
        ],
    },
    {
        title: 'Campañas',
        icon: 'redeem',
        isGroup: true,
        parent: 'campaigns',
        submenu: [
            {
                title: 'Lista de Campañas',
                href: '/admin/campaigns',
                isGroup: false,
            },
        ],
    },
    {
        title: 'Tarjetas',
        icon: 'credit_card',
        isGroup: true,
        parent: 'admin/client-cards',
        submenu: [
            {
                title: 'Lista de Tarjetas',
                href: '/admin/client-cards',
                isGroup: false,
            },
        ],
    },
    {
        title: 'Reportes',
        icon: 'list_alt',
        isGroup: true,
        parent: 'reports',
        submenu: [
            {
                title: 'Tarjetas',
                href: '/admin/reports/client-cards',
                isGroup: false,
            },
            {
                title: 'Historial de Reportes',
                href: '/admin/reports/history',
                isGroup: false,
            },
        ],
    },
    ,
];
var MenuListItems = function (_a) {
    var open = _a.open;
    var location = (0, react_router_dom_1.useLocation)();
    var theme = (0, material_1.useTheme)();
    var user = (0, context_1.useAuth)().user;
    var CustomListItem = function (_a) {
        var to = _a.to, primary = _a.primary, icon = _a.icon, color = _a.color;
        return ((0, jsx_runtime_1.jsxs)(ListItemButtonCustom, __assign({ component: react_router_dom_1.Link, to: to, selected: to === location.pathname, open: true }, { children: [(0, jsx_runtime_1.jsx)(ListItemIcon_1.default, __assign({ style: {
                        minWidth: open ? '45px' : '64px',
                        transition: 'width .3s linear',
                    } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, __assign({ style: {
                            color: color,
                        } }, { children: icon })) })), (0, jsx_runtime_1.jsx)(ListItemText_1.default, { primary: primary, sx: {
                        opacity: { xs: 1, sm: open ? '1' : '0' },
                        transition: 'opacity 1s ease-out',
                    } })] })));
    };
    var _b = react_1.default.useState(function () {
        var _a;
        var arraySubmenu = [];
        var routeParentExists = menuList.find(function (menu) {
            return menu &&
                !!menu.parent &&
                location.pathname.includes(menu.parent) &&
                location.pathname.includes('admin');
        });
        if (!routeParentExists)
            return [];
        if (!!routeParentExists &&
            'parent' in routeParentExists &&
            'submenu' in routeParentExists) {
            arraySubmenu.push((_a = routeParentExists.parent) !== null && _a !== void 0 ? _a : '');
        }
        return arraySubmenu;
    }), openSubmenu = _b[0], setOpenSubmenu = _b[1];
    (0, react_1.useEffect)(function () {
        var _a;
        if (location.pathname) {
            var arraySubmenu = __spreadArray([], openSubmenu, true);
            var routeParentExists_1 = menuList.find(function (menu) {
                return menu &&
                    !!menu.parent &&
                    location.pathname.includes(menu.parent) &&
                    location.pathname.includes('admin');
            });
            if (!routeParentExists_1) {
                return;
            }
            var parentExists = openSubmenu.some(function (m) { return m === routeParentExists_1.parent; });
            if (!parentExists &&
                'parent' in routeParentExists_1 &&
                'submenu' in routeParentExists_1) {
                arraySubmenu.push((_a = routeParentExists_1.parent) !== null && _a !== void 0 ? _a : '');
            }
            setOpenSubmenu(arraySubmenu);
        }
    }, [location.pathname]);
    var handleParentMenuItem = function (sectionName) {
        var parentExists = openSubmenu.some(function (m) { return m === sectionName; });
        var currentIndex = openSubmenu.findIndex(function (mCurrent) { return mCurrent === sectionName; });
        var routeParentExists = menuList.find(function (menu) { return !!menu && !!menu.parent && menu.parent === sectionName; });
        var newMenuSection = __spreadArray([], openSubmenu, true);
        if (!parentExists &&
            routeParentExists &&
            'parent' in routeParentExists &&
            'submenu' in routeParentExists) {
            newMenuSection.push(sectionName);
        }
        else {
            newMenuSection.splice(currentIndex, 1);
        }
        setOpenSubmenu(__spreadArray([], newMenuSection, true));
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: menuList.map(function (menu, i) {
            var _a, _b, _c;
            return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [!!menu &&
                        !!menu.isSectionTitle &&
                        user.role === 'superadmin_rw_admin' ? ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Divider, { style: { marginBlock: '20px' } }), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", sx: {
                                    fontWeight: 500,
                                    textTransform: 'uppercase',
                                    color: '#9d9d9d',
                                    marginBottom: '10px',
                                } }, { children: menu.title }))] })) : null, !!menu &&
                        menu.isGroup &&
                        !!menu.parent &&
                        (user === null || user === void 0 ? void 0 : user.role) === 'superadmin_rw_admin' ? ((0, jsx_runtime_1.jsxs)(material_1.Box, { children: [(0, jsx_runtime_1.jsxs)(ListItemButtonParentCustom, __assign({ onClick: function () { return handleParentMenuItem(menu.parent); }, open: open }, { children: [(0, jsx_runtime_1.jsx)(ListItemIcon_1.default, __assign({ style: {
                                            minWidth: open ? '45px' : '64px',
                                            transition: 'width .3s linear',
                                        } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { children: menu.icon }) })), (0, jsx_runtime_1.jsx)(ListItemText_1.default, { primary: menu.title }), openSubmenu.some(function (m) { return m === menu.parent; }) ? ((0, jsx_runtime_1.jsx)(icons_material_1.ExpandLess, {})) : ((0, jsx_runtime_1.jsx)(icons_material_1.ExpandMore, {}))] })), (0, jsx_runtime_1.jsx)(material_1.Collapse, __assign({ in: openSubmenu.some(function (m) { return m === menu.parent; }), timeout: "auto", unmountOnExit: true }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ style: {
                                        display: 'grid',
                                        gridTemplateColumns: '1.8rem 1fr',
                                        gap: '15px',
                                    } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ style: {
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                            } }, { children: (0, jsx_runtime_1.jsx)(material_1.Divider, { orientation: "vertical", variant: "middle" }) })), (0, jsx_runtime_1.jsx)(material_1.List, __assign({ component: "div", disablePadding: true }, { children: (_a = menu.submenu) === null || _a === void 0 ? void 0 : _a.map(function (submenu, indexC) { return ((0, jsx_runtime_1.jsx)(ListItemButtonChildCustom, __assign({ component: react_router_dom_1.Link, to: submenu.href, selected: submenu.href === location.pathname, open: true }, { children: (0, jsx_runtime_1.jsx)(ListItemText_1.default, { primary: submenu.title }) }), indexC)); }) }))] })) }))] })) : null, !!menu && !menu.isGroup && !!menu.href ? ((0, jsx_runtime_1.jsx)(CustomListItem, { to: (_b = menu.href) !== null && _b !== void 0 ? _b : '', primary: menu.title, icon: (_c = menu.icon) !== null && _c !== void 0 ? _c : '', color: menu.href === location.pathname
                            ? theme.palette.secondary.main
                            : '' })) : null] }, i));
        }) }));
};
exports.default = MenuListItems;
